import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { auth, firestore } from "../../firebase";
import TextField from '@material-ui/core/TextField';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {
  IconButton,
  MenuIcon,
  Box,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    margin: 10,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 9,
    marginTop: 9,
  },
  root1: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.primary,
  },
}));

export default function SimpleCard(props) {
  const classes = useStyles();
  const history = useHistory();
  // const { managerId } = useParams();
  const currentUser = auth.currentUser;
  const [items, setItems] = useState([]);
  const [mobileNumber, setMobileNumber] = useState('');
  const [addPoints, setAddpoints] = useState([]);


  useEffect(() => {
    if (props.roles.includes("admin")) {
      firestore.collection('Managers').where('createdByUserId', '==', currentUser.uid).get().then(querySnapshot => {
        const listItems = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setItems(listItems);
        // console.log("items",listItems);
      });
    } else {
      firestore.collection('Managers').where('email', '==', currentUser.email).get().then(querySnapshot => {
        const listItems = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setItems(listItems);
        // console.log("items",listItems);
      });
    }

  }, []);

  const onDeleteManager = (id) => {
    if (window.confirm("Do you want to delete it?")) {
      firestore.collection('Employees').where('managerId', '==', id).get().then(querySnapshot => {
        if (querySnapshot.size === 0) {
          firestore.collection('Managers')
            .doc(id)
            .delete().then(() => {
              setItems([...items.filter(x => x.id !== id)])
              // alert("Deleted Sucessfully");
              props.openSnackbar("Deleted Successfully");
            });
        } else {
          props.openSnackbar("Please first delete all its workers.");
          return;
        }
      });
    }
    return;
  }

  function changePoints(id, value, items) {
    if (!(Number.isInteger(parseInt(value)))) {
      return;
    }
    var newItems = [...items];
    for (var i in newItems) {
      if (newItems[i].id === id) {
        newItems[i].rewards = parseInt(newItems[i].rewards) + parseInt(value);
        setItems(newItems);
        break; //Stop this loop, we found it!
      }
    }
  }


  const onAddPoints = (id) => {
    var date = new Date();
    var pointedAdded = getValue(id);

    var updatedItem = items.find(x => x.id === id);
    firestore.collection('Managers')
      .doc(id).update({ ...updatedItem, rewards: parseInt(updatedItem.rewards) + parseInt(pointedAdded) }).then(() => {
        firestore.collection('ManagerTransactions').add({
          managerId: id,
          transactionDoneBy: currentUser.email,
          transactionDate: date.toString(),
          createdDate: date.toString(),
          previousPoints: parseInt(updatedItem.rewards),
          pointsAdded: pointedAdded,
          balance: parseInt(updatedItem.rewards) + parseInt(pointedAdded),
          createdByUserId: currentUser.uid,
          timestamp: new Date(),
        }).then(() => {
          props.openSnackbar("Transaction Successful.");
          changePoints(id, getValue(id), items);
          setAddpoints([...addPoints.filter(x => x.id !== id)]);
        });
      });
  }

  const getValue = (id) => {
    if (addPoints && addPoints.length > 0) {
      var result = addPoints.find(x => x.id === id);
      return result && result.rewards;
    }
    return 0;
  }

  return (
    <>
      <div className={classes.root1}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper>
              <Box display="flex" flexGrow={1}>
                <IconButton onClick={() => { history.goBack(); }} edge="end" color="inherit" aria-label="back">
                  <ArrowBackIosIcon />
                </IconButton>
                <Box flexGrow={1}>
                </Box>
                <Box flexGrow={1}>
                  <Typography className={classes.paper} variant="h6" component="h4">
                    My Parties
                  </Typography>
                </Box>
                <Box flexGrow={1}>
                </Box>
                <IconButton edge="start" color="inherit" aria-label="back">
                  <ArrowBackIosIcon htmlColor="white" />
                </IconButton>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </div>
      <div>
        <TextField
          id="filled-number"
          label="Search Using Mobile Number"
          type="number"
          onInput={(e) => {
            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10);
            setMobileNumber(e.target.value);
          }}
          placeholder="9723622285"
          variant="outlined"
          fullWidth
          margin="normal"
          value={mobileNumber}
        />
        {items.filter(x => {
          if (mobileNumber !== '') {
            return x.mobileNumber.includes(mobileNumber);
          }
          return true;
        }).map((item) => (
          <React.Fragment >
            <Card className={classes.root}>
              <CardContent>
                <Typography variant="h5" component="h4">
                  <u>{item.name}</u>
                </Typography>
                <Typography className={classes.pos}>
                  {item.mobileNumber}
                </Typography>
                <Typography className={classes.pos}>
                  {item.rewards} Points
                </Typography>
                <Typography className={classes.pos}>
                  {item.location}
                </Typography>
                <Typography className={classes.pos}>
                  {item.desc}
                </Typography>
                <Typography className={classes.pos}>
                  {item.email}
                </Typography>
              </CardContent>
              <CardActions>
                <Grid item xs={12}>
                  {props.roles.includes("admin") && (
                    <><TextField
                      id={"reward point" + item.id}
                      label="Reward Points"
                      type="number"
                      onInput={(e) => {
                        if (!(Number.isInteger(parseInt(e.target.value)))) {
                          return;
                        }
                        if (addPoints && addPoints.length > 0 && addPoints.find(x => x.id === item.id)) {
                          var points = [...addPoints];
                          for (var i in points) {
                            if (points[i].id === item.id) {
                              points[i].rewards = parseInt(e.target.value);
                              setAddpoints(points);
                              break; //Stop this loop, we found it!
                            }
                          }
                        } else {
                          addPoints.push({ id: item.id, rewards: parseInt(e.target.value) });
                        }

                      }}
                      placeholder="50"
                      variant="filled"
                      fullWidth
                      margin="normal" />
                      <Button fullWidth variant="contained" className={classes.pos} color="primary" onClick={() => onAddPoints(item.id)} size="medium">Assign Points</Button></>
                  )}
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <Button fullWidth variant="contained" className={classes.pos} color="primary" onClick={() => history.push(`/managers/${item.id}/employee`)} size="medium">Show Details</Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button fullWidth variant="contained" className={classes.pos} color="primary" onClick={() => history.push(`/managers/${item.id}/addEmployee`)} size="medium">Add Worker</Button>

                    </Grid>
                  </Grid>
                  <Button fullWidth variant="contained" className={classes.pos} color="primary" onClick={() => history.push(`/managertransactions/${item.id}`)} size="medium">Transactions</Button>

                </Grid> </CardActions>
              <CardActions>
                {props.roles.includes("admin") && (
                  <Button fullWidth variant="contained" onClick={() => { onDeleteManager(item.id) }} color="secondary" size="medium">Delete Party</Button>
                )}

              </CardActions>

            </Card>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}
